/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, BreadcrumbItem } from '@carbon/react';
import callIf from '../utils/callIf.js';

var SidePanelBreadcrumbs = function SidePanelBreadcrumbs(_ref) {
  var activePanelId = _ref.activePanelId,
    breadcrumbs = _ref.breadcrumbs,
    onBreadCrumbClick = _ref.onBreadCrumbClick,
    onPageSelect = _ref.onPageSelect,
    onTabToPrev = _ref.onTabToPrev;
  return /*#__PURE__*/React.createElement(Breadcrumb, {
    noTrailingSlash: true,
    className: "cpc--side-panel__breadcrumbs",
    "aria-label": "Side Panel Breadcrumbs"
  }, breadcrumbs.map(function (_ref2, index) {
    var breadCrumbId = _ref2.id,
      value = _ref2.value;
    return /*#__PURE__*/React.createElement(BreadcrumbItem, {
      key: breadCrumbId,
      href: "#",
      isCurrentPage: breadCrumbId === activePanelId,
      className: "cds--side-panel__breadcrumb-item",
      "aria-label": "Side Panel Breadcrumb Item",
      onClick: function onClick(e) {
        e.preventDefault();
        callIf(onBreadCrumbClick, function () {
          return onPageSelect(breadCrumbId);
        })(e);
      },
      onKeyDown: function onKeyDown(e) {
        if (index === 0) {
          onTabToPrev(e);
        }
      }
    }, value);
  }));
};
SidePanelBreadcrumbs.propTypes = {
  activePanelId: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    id: PropTypes.string
  })).isRequired,
  onBreadCrumbClick: PropTypes.func.isRequired,
  onPageSelect: PropTypes.func.isRequired,
  onTabToPrev: PropTypes.func.isRequired
};
var SidePanelBreadcrumbs$1 = SidePanelBreadcrumbs;

export { SidePanelBreadcrumbs$1 as default };
